import { Controller } from 'stimulus';
import { loadStripe } from '@stripe/stripe-js';

export default class extends Controller {
  static targets = ["card", "wallet", "submit", "amount", "error", "name", "email"]

  connect() {
    this.mount()
  }

  async mount() {
    this.stripe = await loadStripe(this.key)
    this.elements = this.generateElements()
    this.paymentElement = this.elements.create("payment", { wallets: { applePay: "never", googlePay: "never"} });
    this.paymentElement.mount(this.cardTarget);
    if (this.hasWalletTarget) {
      this.generateWalletButtonElement()
    }
    this.isMountedValue = true
  }

  async handleSubmit(event) {
    event.preventDefault();
    $.rails.disableFormElement($(this.submitTarget))
    try {
      const { error } = await this.confirmSetup()
      if (error) {
        console.error("Whoa there! Something went wrong with that card.")
        this.showErrorMessage(error)
         $.rails.enableFormElement($(this.submitTarget))
      } else {
        this.errorTarget.hidden = true
        this.submitForm()
      }
    } catch (error) {
      console.error("Whoa there! Something went wrong with that card.", error)
       $.rails.enableFormElement($(this.submitTarget))
    }
  }

  submitForm() {
    console.log('submitting...')
    this.element.requestSubmit()
  }

  // private

  generateElements() {
    const options = this.options
    return this.stripe.elements(options)
  }

  async generateWalletButtonElement() {
    this.paymentRequest = this.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Podcast Supporter',
        amount: this.amount,
      },
      requestPayerName: true,
      requestPayerEmail: true,
    })

    this.paymentRequest.on("paymentmethod", async (event) => {
      const { setupIntent, error } =
        await this.stripe.confirmCardSetup(this.clientSecretValue,
        { payment_method: event.paymentMethod.id },
        { handleActions: false }
      )

      if (error) {
        console.log('something went wrong during setup', error)
        event.complete('fail');
      } else {
        event.complete('success');
        this.formTarget.requestSubmit()
        if (setupIntent.status === "requires_action") {
          // Let Stripe.js handle the rest of the payment flow.
          console.log("Requires Action")
        } else {
          // The payment has succeeded.
        }
      }
    })

    this.walletElement = this.elements.create('paymentRequestButton', {
      paymentRequest: this.paymentRequest,
    })

    const result = await this.paymentRequest.canMakePayment()
    if (result) {
      this.walletElement.mount(this.walletTarget)
    }
  }

  async confirmSetup() {
    return (
      this.stripe.confirmSetup({ elements: this.elements,
        redirect: "if_required",
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: this.nameTarget.value,
              email: this.emailTarget.value,
            }
          }
        }
      })
    )
  }

  showErrorMessage(error) {
    console.log("error!", error)
    this.errorTarget.hidden = false
    this.errorTarget.textContent = `${error.message} You can try a different card or contact support at support@buzzsprout.com.`
  }

  get key() {
    return this.data.get("key")
  }

  get clientSecretValue() {
    return this.data.get("client-secret")
  }

  get options() {
    return {
      appearance,
      clientSecret: this.clientSecretValue,
    }
  }

  get amount() {
    return this.amountTarget.value * 100
  }
}

const appearance = {
  rules: {
    '.Label': {
      color: "#000000",
      fontWeight: "normal",
      fontSize: "17px",
    },
    '.Input': {
      padding: "12px 9px 12px 9px",
      border: "2px solid #EEEEEE",
      boxShadow: "none",
    }
  }
};

